/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Shop_Home_Schedule_FromInputs */

const vi_shop_home_schedule_from = /** @type {(inputs: Shop_Home_Schedule_FromInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Từ ${i?.date}`)
};

/**

* @param {Shop_Home_Schedule_FromInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_schedule_from = /** @type {((inputs: Shop_Home_Schedule_FromInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Schedule_FromInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_schedule_from(inputs)
});